import * as Yup from 'yup';

export const requestAdImagesYopValidation = () => {
  return Yup.object().shape({
    email: Yup.string().required('required').email('incorrectEmail'),
    userName: Yup.string()
      .required('required')
      .matches(/^[\p{L}\s-]+$/u, 'invalidUserName'),
    companyName: Yup.string().required('required'),
  });
};
